export default __webpack_public_path__ + "static/media/ISC-PropEx-Sale&Purchase.b966acab.png";